import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-copy-right',
  templateUrl: './copy-right.component.html',
  styleUrls: ['./copy-right.component.css']
})
export class CopyRightComponent implements OnInit {

  copyrightVerbiage = '';
  companyName = 'Bureau of the Fiscal Service';

  constructor() { }

  ngOnInit() {
    const date = new Date();
    const year = date.getFullYear();
    this.copyrightVerbiage = '© ' + year + ' '  + this.companyName;
  }

}
